<template>
  <page :title="title">
    <v-container fluid grid-list-sm>
      <v-card>
        <v-card-text>
          <v-layout row wrap align-center>
            <v-flex xs12 sm6>
              <v-text-field
                v-model="form.branch"
                :label="labels.branch"
                :error-messages="errors.collect('form.branch')"
                data-vv-name="form.branch"
                :data-vv-as="labels.branch"
                append-icon="mdi-magnify"
                readonly
                @click="showBranchHelpList = true"
                clearable
                v-validate="'required'"
                @change="form.docNo = ''"
              />
            </v-flex>
            <v-flex xs12 class="ma-0 pa-0" />
            <v-flex xs12 sm6>
              <v-text-field
                v-model="form.fund"
                :label="labels.fund"
                :error-messages="errors.collect('form.fund')"
                data-vv-name="form.fund"
                :data-vv-as="labels.fund"
                append-icon="mdi-magnify"
                readonly
                @click="showFundHelpList = true"
                clearable
                v-validate="'required'"
                @change="form.docNo = ''"
              />
            </v-flex>
            <v-flex xs12 class="ma-0 pa-0" />
            <v-flex xs12 sm6>
              <v-autocomplete
                :items="tranTypes"
                v-model="form.tranType"
                :label="labels.tranType"
                item-text="label"
                item-value="value"
                data-vv-name="form.tranType"
                :data-vv-as="labels.tranType"
                :error-messages="errors.collect('form.tranType')"
                clearable
                v-validate="'required'"
                @change="form.docNo = ''"
              />
            </v-flex>
            <v-flex xs12 class="ma-0 pa-0" />
            <v-flex xs12 sm6>
              <v-text-field
                v-model="form.docNo"
                :label="labels.docNo"
                :error-messages="errors.collect('form.docNo')"
                data-vv-name="form.docNo"
                :data-vv-as="labels.docNo"
                append-icon="mdi-magnify"
                readonly
                @click="showDocNoHelpList = true"
                clearable
                v-validate="'required'"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="doSubmit">
            {{ labels.submit }}
            <v-icon right>mdi-clipboard-check</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
    <v-dialog v-model="showDocDetails" width="1280px" persistent>
      <v-card>
        <v-toolbar dense color="grey lighten-2" flat>
          <v-icon>mdi-format-list-bulleted</v-icon>
          <v-toolbar-title class="toolbar-title-3">Claim Document</v-toolbar-title>
        </v-toolbar>
        <v-card-text style="max-height: 700px; overflow-y: auto">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex sm4 xs12>
                <v-subheader class="queryLabel">Branch</v-subheader>
                <div class="subheading">{{ clmDoc.branch }}</div>
              </v-flex>
              <v-flex>
                <v-subheader class="queryLabel">{{ labels.cseStat }}</v-subheader>
                <div class="subheading">{{ clmDoc.cseStat }}</div>
              </v-flex>
              <v-flex sm4 xs12>
                <v-subheader class="queryLabel">{{ labels.tranDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(new Date(clmDoc.tranDate)) }}</div>
              </v-flex>
              <v-flex sm4 xs12>
                <v-subheader class="queryLabel">{{ labels.tranType }}</v-subheader>
                <div class="queryValue">{{ clmDoc.tranType1 }}</div>
              </v-flex>
              <v-flex sm4 xs12>
                <v-subheader class="queryLabel">{{ labels.docNo }}</v-subheader>
                <div class="queryValue">{{ clmDoc.docNo }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex sm4 xs12>
                <v-subheader class="queryLabel">{{ labels.payInsd }}</v-subheader>
                <div class="queryValue">{{ clmDoc.payInsd ? 'Yes' : 'No' }}</div>
              </v-flex>
              <v-flex sm4 xs12>
                <v-subheader class="queryLabel">{{ labels.payeeAcctNo }}</v-subheader>
                <div class="queryValue">{{ clmDoc.payeeAcctNo }}</div>
              </v-flex>
              <v-flex sm4 xs12 />
              <v-flex sm4 xs12>
                <v-subheader class="queryLabel">{{ labels.acctNoSfx }}</v-subheader>
                <div class="queryValue">{{ clmDoc.acctNoSfx }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex sm4 xs12>
                <v-subheader class="queryLabel">{{ labels.titleName }}</v-subheader>
                <div class="queryValue">{{ clmDoc.titleName }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex sm4 xs12>
                <v-subheader class="queryLabel">{{ labels.name }}</v-subheader>
                <div class="queryValue">{{ clmDoc.name }}</div>
                <div class="queryValue">{{ clmDoc.name2 }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-subheader class="queryLabel">{{ labels.addr }}</v-subheader>
                <div class="queryValue">{{ clmDoc.addr1 }}</div>
                <div class="queryValue">{{ clmDoc.addr2 }}</div>
                <div class="queryValue">{{ clmDoc.addr3 }}</div>
                <div class="queryValue">{{ clmDoc.addr4 }}</div>
              </v-flex>
              <v-flex sm4 xs12>
                <v-subheader class="queryLabel">{{ labels.postCode }}</v-subheader>
                <div class="queryValue">{{ clmDoc.postCode }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex sm4 xs12>
                <v-subheader class="queryLabel">{{ labels.stmtRef }}</v-subheader>
                <div class="queryValue">{{ clmDoc.stmtRef }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex sm4 xs12>
                <v-subheader class="queryLabel">{{ labels.inOutGst }}</v-subheader>
                <div class="queryValue">{{ clmDoc.inOutGst }}</div>
              </v-flex>
              <v-flex sm4 xs12>
                <v-subheader class="queryLabel">{{ labels.deemGst }}</v-subheader>
                <div class="queryValue">{{ clmDoc.deemGst ? 'Yes' : 'No' }}</div>
              </v-flex>
              <v-flex sm4 xs12>
                <v-subheader class="queryLabel">{{ labels.bankNo }}</v-subheader>
                <div class="queryValue">{{ clmDoc.bankNo }}</div>
              </v-flex>
              <v-flex sm4 xs12>
                <v-subheader class="queryLabel">{{ labels.payChqNo }}</v-subheader>
                <div class="queryValue">{{ clmDoc.payChqNo }}</div>
              </v-flex>
              <v-flex sm4 xs12>
                <v-subheader class="queryLabel">{{ labels.cheque }}</v-subheader>
                <div class="queryValue">{{ clmDoc.cheque }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex sm4 xs12>
                <v-subheader class="queryLabel">{{ labels.prtClmPv }}</v-subheader>
                <div class="queryValue">{{ clmDoc.prtClmPv }}</div>
              </v-flex>
              <v-flex sm4 xs12>
                <v-subheader class="queryLabel">{{ labels.prtCseLoss }}</v-subheader>
                <div class="queryValue">{{ clmDoc.prtCseLoss ? 'Yes' : 'No' }}</div>
              </v-flex>
              <v-flex sm4 xs12>
                <v-subheader class="queryLabel">{{ labels.prtClmtName }}</v-subheader>
                <div class="queryValue">{{ clmDoc.prtClmtName ? 'Yes' : 'No' }}</div>
              </v-flex>
              <v-flex sm4 xs12>
                <v-subheader class="queryLabel">{{ labels.prtLossDesc }}</v-subheader>
                <div class="queryValue">{{ clmDoc.prtLossDesc ? 'Yes' : 'No' }}</div>
              </v-flex>
              <v-flex xs12 style="height: 20px">
                <span> </span>
              </v-flex>
            </v-layout>
          </v-container>
          <v-expansion-panels v-model="panels" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-icon>mdi-format-list-bulleted</v-icon>
                <v-toolbar-title class="toolbar-title-3">Payment Details</v-toolbar-title>
              </v-expansion-panel-header>
              <template v-if="clmPays">
                <v-expansion-panel-content v-for="(claimPay, index) in clmPays" :key="index" :class="claimPay.hClass">
                  <div slot="header">
                    <div class="body-2">
                      {{ claimPay.clmNo }} / {{ claimPay.clmtNo }} - {{ claimPay.clmtNo }} / Item {{ claimPay.clmItem }} / {{ claimPay.clmResCat }}
                    </div>
                  </div>
                  <v-card>
                    <v-card-text :key="claimPay.clmResCat">
                      <v-container fluid grid-list-xs>
                        <v-layout row wrap>
                          <v-flex sm3 xs12>
                            <v-subheader class="queryLabel">{{ labels.settCode }}</v-subheader>
                            <div class="subheading">{{ claimPay.settCode }}</div>
                          </v-flex>
                          <v-flex sm3 xs12>
                            <v-subheader class="queryLabel">{{ labels.rcvrPi }}</v-subheader>
                            <div class="subheading">{{ claimPay.rcvrPi ? 'Yes' : 'No' }}</div>
                          </v-flex>
                          <v-flex sm3 xs12>
                            <v-subheader class="queryLabel">{{ labels.isSuppGstreg }}</v-subheader>
                            <div class="subheading">{{ claimPay.isSuppGstreg ? 'Yes' : 'No' }}</div>
                          </v-flex>
                          <v-flex sm3 xs12>
                            <v-subheader class="queryLabel">{{ labels.theirTaxInv }}</v-subheader>
                            <div class="subheading">{{ claimPay.theirTaxInv }}</div>
                          </v-flex>
                          <v-flex sm3 xs12>
                            <v-subheader class="queryLabel">{{ labels.dvInvDate }}</v-subheader>
                            <div class="subheading">{{ formatDisplayDate(claimPay.dvInvDate) }}</div>
                          </v-flex>
                          <v-flex sm3 xs12>
                            <v-subheader class="queryLabel">{{ labels.clmPaytType }}</v-subheader>
                            <div class="subheading">{{ claimPay.clmPaytType }}</div>
                          </v-flex>
                          <v-flex sm3 xs12>
                            <v-subheader class="queryLabel">{{ labels.paytDet }}</v-subheader>
                            <div class="subheading">{{ claimPay.paytDet }}</div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex sm3 xs12>
                            <v-subheader class="queryLabel">{{ labels.curr }}</v-subheader>
                            <div class="subheading">{{ claimPay.curr }}</div>
                          </v-flex>
                          <v-flex sm3 xs12>
                            <v-subheader class="queryLabel">{{ labels.exRate }}</v-subheader>
                            <div class="subheading">{{ formatDisplayNumber(claimPay.exRate, 6) }}</div>
                          </v-flex>
                          <v-flex sm3 xs12>
                            <v-subheader class="queryLabel">{{ labels.riRcvyCurr }}</v-subheader>
                            <!--div class="subheading">{{getItemValue(claimPayHeader.riRcvyCurr, currencyItems).label}}</div-->
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex lg3 md3 xs6>
                            <v-subheader class="queryLabel">{{ labels.paytAmt }}</v-subheader>
                            <div class="subheading">{{ formatDisplayNumber(claimPay.paytAmt, 2) }}</div>
                          </v-flex>
                          <v-flex lg3 md3 xs6>
                            <v-subheader class="queryLabel">{{ labels.paytAmtLoc }}</v-subheader>
                            <div class="subheading">{{ formatDisplayNumber(claimPay.paytAmtLoc, 2) }}</div>
                          </v-flex>
                          <v-flex sm6 xs12> </v-flex>
                          <v-flex lg3 md3 xs6>
                            <v-subheader class="queryLabel">{{ labels.paytAmtTax }}</v-subheader>
                            <div class="subheading">{{ formatDisplayNumber(claimPay.paytAmtTax, 2) }}</div>
                          </v-flex>
                          <v-flex lg3 md3 xs6>
                            <v-subheader class="queryLabel">{{ labels.paytAmtTaxLoc }}</v-subheader>
                            <div class="subheading">{{ formatDisplayNumber(claimPay.paytAmtTaxLoc, 2) }}</div>
                          </v-flex>
                          <v-flex sm6 xs12> </v-flex>
                          <v-flex lg3 md3 xs6>
                            <v-subheader class="queryLabel">{{ labels.gstStat }}</v-subheader>
                            <div class="subheading">{{ claimPay.gstStat }}</div>
                          </v-flex>
                          <v-flex lg3 md3 xs6>
                            <v-subheader class="queryLabel">{{ labels.gstRate }}</v-subheader>
                            <div class="subheading">{{ formatDisplayNumber(claimPay.gstRate, 2) }}</div>
                          </v-flex>
                          <v-flex sm6 xs12> </v-flex>
                          <v-flex lg3 md3 xs6>
                            <v-subheader class="queryLabel">{{ labels.gstAmt }}</v-subheader>
                            <div class="subheading">{{ formatDisplayNumber(claimPay.gstAmt, 2) }}</div>
                          </v-flex>
                          <v-flex lg3 md3 xs6>
                            <v-subheader class="queryLabel">{{ labels.gstAmtLoc }}</v-subheader>
                            <div class="subheading">{{ formatDisplayNumber(claimPay.gstAmtLoc, 2) }}</div>
                          </v-flex>
                          <v-flex sm6 xs12> </v-flex>
                          <v-flex lg3 md3 xs6>
                            <v-subheader class="queryLabel">{{ labels.netAmt }}</v-subheader>
                            <div class="subheading">{{ formatDisplayNumber(claimPay.netAmt, 2) }}</div>
                          </v-flex>
                          <v-flex lg3 md3 xs6>
                            <v-subheader class="queryLabel">{{ labels.netAmtLoc }}</v-subheader>
                            <div class="subheading">{{ formatDisplayNumber(claimPay.netAmtLoc, 2) }}</div>
                          </v-flex>
                          <v-flex sm6 xs12> </v-flex>
                          <v-flex lg12 md12 xs36>
                            <v-subheader class="queryLabel">{{ labels.bankAcctCurr }}</v-subheader>
                            <!--div class="subheading">{{getItemValue(bankChrgResCurr, currencyItems).label}}</div-->
                          </v-flex>
                          <v-flex lg3 md3 xs12>
                            <v-subheader class="queryLabel">{{ labels.bankChrg }}</v-subheader>
                            <div class="subheading">{{ formatDisplayNumber(claimPay.bankChrg, 2) }}</div>
                          </v-flex>
                          <v-flex lg3 md3 xs12>
                            <v-subheader class="queryLabel">{{ labels.bankChrgLoc }}</v-subheader>
                            <div class="subheading">{{ formatDisplayNumber(claimPay.bankChrgLoc, 2) }}</div>
                          </v-flex>
                          <v-flex lg3 md3 xs12>
                            <v-subheader class="queryLabel">{{ labels.bankChrgRes }}</v-subheader>
                            <div class="subheading">{{ formatDisplayNumber(claimPay.bankChrgRes, 2) }}</div>
                          </v-flex>
                          <v-flex lg3 md3 xs12> </v-flex>
                          <v-flex lg3 md3 xs12>
                            <v-subheader class="queryLabel">{{ labels.prtOffSettLtr }}</v-subheader>
                            <div class="subheading">{{ claimPay.prtOffSettLtr ? 'Yes' : 'No' }}</div>
                          </v-flex>
                          <v-flex lg3 md3 xs12>
                            <v-subheader class="queryLabel">{{ labels.prtClmDv }}</v-subheader>
                            <div class="subheading">{{ claimPay.prtClmDv ? 'Yes' : 'No' }}</div>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </template>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-card>
            <v-card-text>
              <v-layout row wrap>
                <v-flex lg3 md3 xs6>
                  <v-subheader class="queryLabel">{{ labels.totAmt }}</v-subheader>
                  <div class="subheading">{{ formatDisplayNumber(clmDoc.netAmt, 2) }}</div>
                </v-flex>
                <v-flex lg3 md3 xs6>
                  <v-subheader class="queryLabel">{{ labels.totAmtLoc }}</v-subheader>
                  <div class="subheading">{{ formatDisplayNumber(clmDoc.netAmtLoc, 2) }}</div>
                </v-flex>
                <v-flex sm6 xs12> </v-flex>
                <v-flex lg3 md3 xs6>
                  <v-subheader class="queryLabel">{{ labels.totAmtTax }}</v-subheader>
                  <div class="subheading">{{ formatDisplayNumber(clmDoc.paytAmtTax, 2) }}</div>
                </v-flex>
                <v-flex lg3 md3 xs6>
                  <v-subheader class="queryLabel">{{ labels.totAmtTaxLoc }}</v-subheader>
                  <div class="subheading">{{ formatDisplayNumber(clmDoc.paytAmtTaxLoc, 2) }}</div>
                </v-flex>
                <v-flex sm6 xs12>
                  <v-subheader class="queryLabel">{{ labels.totAmtRes }}</v-subheader>
                  <div class="subheading">{{ formatDisplayNumber(clmDoc.netAmtRes, 2) }}</div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click.native="sendRequest">Unset Print Flag</v-btn>
          <v-btn color="secondary" @click.native="showDocDetails = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showDocNoHelpList" width="1280px" persistent>
      <clm-doc-help-list
        :branch="form.branch"
        :fund="form.fund"
        :tranType="form.tranType"
        :docPrtd="form.docPrtd"
        :boolRefresh="showDocNoHelpList"
        @close="showDocNoHelpList = false"
        @assign-doc-no-info="assignDocNoInfo"
      ></clm-doc-help-list>
    </v-dialog>
    <v-dialog v-model="showFundHelpList" width="1280px" persistent>
      <fund-help-list @close="showFundHelpList = false" @assign-fund="assignFund"></fund-help-list>
    </v-dialog>
    <v-dialog v-model="showBranchHelpList" width="1280px" persistent>
      <branch-help-list @close="showBranchHelpList = false" @assign-branch="assignBranch"></branch-help-list>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import BranchHelpList from '@/components/core/common/dialog/BranchHelpList'
import ClmDocHelpList from '@/components/core/common/dialog/ClmDocHelpList'
import FundHelpList from '@/components/core/common/dialog/FundHelpList'
import { ClaimCommonMixin } from '@/mixins/claim/ClaimCommonMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { formatDisplayNumber } from '@/utils/number'
import { formatDisplayDate } from '@/utils/date'
export default {
  components: {
    BranchHelpList,
    ClmDocHelpList,
    FundHelpList
  },
  mixins: [MessageMixin, ClaimCommonMixin, commonAjaxMixin],
  data() {
    return {
      totAmt: 0,
      totAmtLoc: 0,
      totAmtTax: 0,
      totAmtTaxLoc: 0,
      totAmtRes: 0,
      panels: [],
      clmDoc: {},
      form: {
        branch: this.$store.state.token.userBranch,
        fund: '',
        tranType: '',
        docNo: '',
        docPrtd: true
      },
      labels: {
        branch: 'Branch',
        fund: 'Fund',
        tranType: 'Transaction Type',
        docNo: 'Document No.',
        submit: 'Submit',
        clmtName: 'Claimant Name',
        clmItem: 'Claim Item',
        clmClsd: 'Close Claim',
        dept: 'Department',
        cseStat: 'Cause of Status',
        tranType1: 'Transaction Type',
        docNoAE: 'Is New Document No. ?',
        autoDocNo: 'Auto Payment No',
        payChqNo: 'Cheque or GIRO',
        tranDate: 'Transaction Date',
        acctNoSfx: 'Suffix',
        inOutGst: 'GST I/O',
        deemGst: 'Deemed GST',
        curr: 'Currency',
        exRate: 'Exchange Rate',
        riRcvyCurr: 'RI Recovery Currency',
        prtClmPv: 'Print Document',
        prtCseLoss: 'Print Cause of Loss',
        titleName: 'Salutation',
        prtClmtName: 'Print Claimant Name',
        name: 'Name',
        name2: 'Name2',
        addr: 'Address',
        prtLossDesc: 'Print Description of Loss',
        prtOffSettLtr: 'Print Offer Settlement Letter',
        addr1: 'Address',
        addr2: '',
        addr3: '',
        addr4: '',
        postCode: 'Postal Code',
        stmtRef: 'Statement Reference',
        bankNo: 'Bank No.',
        cheque: 'Cheque No.',
        bankAcctCurr: 'Bank Charges Currency',
        settCode: 'Settlement Code',
        clmResCat: 'Reserve Category',
        rcvrPi: 'Recovery from P&I',
        payInsd: 'Pay to Insured',
        payeeAcctNo: 'Payee',
        clmPaytType: 'Payment Type',
        paytDet: 'Payment Details',
        isSuppGstreg: 'Is Supplier GST Registered ?',
        theirTaxInv: 'Their Tax Invoice No.',
        dvInvDate: 'DV/Invoice Date',
        pastReversal: undefined,
        paytAmt: 'Claim Payment (excl GST)',
        paytAmtLoc: 'Local Claim Payment (excl GST)',
        paytAmtTax: 'Amount Taxable',
        paytAmtTaxLoc: 'Local Amount Taxable',
        gstStat: 'GST Status',
        gstRate: 'GST Rate',
        gstAmt: 'GST Amount',
        gstAmtLoc: 'Local GST Amount',
        netAmt: 'Net Amount',
        netAmtLoc: 'Local Net Amount',
        bankChrg: 'Bank Charges',
        bankChrgLoc: 'Local Bank Charges',
        prtClmDv: 'Print Discharge Voucher',
        totAmt: 'Total Amount',
        totAmtLoc: 'Local Total Amount',
        totAmtRes: 'Total Amount (in Reserve Currency)',
        totAmtTax: 'Total Taxable Amount',
        totAmtTaxLoc: 'Local Total Taxable Amount',
        bankChrgRes: 'Bank Charges (in Reserve Currency)'
      },
      title: 'Unset Claims Document Print Flag',
      showFundHelpList: false,
      showBranchHelpList: false,
      showDocNoHelpList: false,
      showDocDetails: false,
      tranTypes: [
        { label: 'X - Credit Note', value: 'X' },
        { label: 'W - Debit Note', value: 'W' },
        { label: 'Z - Payment Voucher', value: 'Z' },
        { label: 'Y - Receipt', value: 'Y' }
      ],
      currencyItems: [],
      gstRates: []
    }
  },
  mounted() {
    this.fetchCurrecyData()
  },
  computed: {
    unsetClmDocPrtFlag() {
      return this.$store.state.unsetClmDocPrtFlag
    },
    menu() {
      return this.unsetClmDocPrtFlag.menu
    },
    clmPays() {
      if (this.clmDoc && this.clmDoc.clmPays) {
        return this.clmDoc.clmPays
      }
      return []
    }
  },
  methods: {
    assignFund(fund) {
      this.form.fund = fund
      this.showFundHelpList = false
      this.$validator.validate('form.fund')
    },
    assignBranch(branch) {
      this.form.branch = branch
      this.showBranchHelpList = false
      this.$validator.validate('form.branch')
    },
    assignDocNoInfo(clmDoc) {
      this.clmDoc = clmDoc
      if (clmDoc.clmPays) {
        this.panels = []
        for (let x = 1; x <= clmDoc.clmPays.length; x++) {
          this.panels.push(false)
        }
      }
      this.form.docNo = clmDoc.docNo
      this.form.branch = clmDoc.branch
      this.form.fund = clmDoc.fund
      this.form.tranType = clmDoc.tranType1
      this.$validator.validateAll()
    },
    doSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.showDocDetails = true
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async sendRequest() {
      const apiURI = this.menu.unsetClmDocPrtFlag
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.$toast.success('Claim document print flag reset successfully')
          this.form.docNo = undefined
          this.form.fund = undefined
          this.form.tranType = undefined
          this.submitting = false
          this.showDocDetails = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    formatDisplayDate(val) {
      return formatDisplayDate(val)
    },
    formatDisplayNumber(val, dec) {
      return formatDisplayNumber(val, dec)
    }
  }
}
</script>
